import { render } from "./cloudflare_attachments.vue?vue&type=template&id=71cbc2aa&scoped=true"
import script from "./cloudflare_attachments.vue?vue&type=script&lang=js"
export * from "./cloudflare_attachments.vue?vue&type=script&lang=js"

import "./cloudflare_attachments.vue?vue&type=style&index=0&id=71cbc2aa&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cbc2aa"]])

export default __exports__